import { types } from '../types/types';

const initialState = {
	groupConcernsSave: []
};

export const groupConcernReducer = (state = initialState, action) => {
	switch (action.type) {
		case types.GROUPCONCERN_START_REGISTER_LIST:
			return {
				...state,
				groupConcernsSave: action.payload,
			};

		default:
			return state;
	}
};
